document.addEventListener("DOMContentLoaded", function () {
    let currentVariantId = "";
    let currentBasePrice = 0;
    let currentBaseComparePrice = 0;

    function setInitialVariantData() {
        const variantSelect = document.getElementById("variant-select");
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        const price = selectedOption.getAttribute("data-price");
        const comparePrice = selectedOption.getAttribute("data-compare-price");

        currentVariantId = selectedOption.value;
        currentBasePrice = price ? Math.round(parseInt(price) / 100) : 0;
        currentBaseComparePrice = comparePrice
            ? Math.round(parseInt(comparePrice) / 100)
            : 0;

        let initialRegularPrice = $(
            ".product__info-container .price-review-wrap .price__regular .price-item--regular"
        )
            .text()
            .trim();
        let initialSalePrice = $(
            ".product__info-container .price-review-wrap .price__sale .price-item--sale"
        )
            .text()
            .trim();
        const initialPrice =
            initialRegularPrice == initialSalePrice
                ? initialRegularPrice
                : initialSalePrice;

        mainProductPrice = parseFloat(initialPrice.replace(/[^0-9.]/g, ""));
        $(":is(.product-form__submit, .button--addon-popup, .addtocart-btn-trigger button) .total-price").text(`(${initialPrice})`);

    }
    setInitialVariantData();

    function updatePrice(price, compareAtPrice) {
        const priceValue = price ? parseInt(price.replace(/[^0-9.]/g, "")) : 0;
        const compareAtPriceValue = compareAtPrice
            ? parseInt(compareAtPrice.replace(/[^0-9.]/g, ""))
            : 0;
        const btnTotalPrice = $(":is(.product-form__submit, .button--addon-popup, .addtocart-btn-trigger button) .total-price");

        if (compareAtPrice && compareAtPriceValue > priceValue) {
            const salePriceElement = document.querySelector(
                ".product__info-container .price-review-wrap .price__sale .price-item--sale"
            );
            const regularPriceElement = document.querySelector(
                ".product__info-container .price-review-wrap .price__sale .price-item--regular"
            );
            if (salePriceElement && price) {
                salePriceElement.textContent = price;
            }
            if (regularPriceElement && compareAtPrice) {
                regularPriceElement.textContent = compareAtPrice;
            }
        } else {
            const regularPriceElement = document.querySelector(
                ".product__info-container .price-review-wrap .price__regular .price-item--regular"
            );
            if (regularPriceElement && price) {
                regularPriceElement.textContent = price;
            }
        }
        mainProductPrice = parseFloat(price.replace(/[^0-9.]/g, ""));
        btnTotalPrice.text(`(${price.replace(/ /g, "")})`);
    }

    function calculateCombinedPrice() {
        const quantityInput = document.getElementById("extra-stem-quantity");
        const addonInputs = $(".product .addon-wrapper .addons-item input:checked");
        let basePrice = currentBasePrice;
        let baseComparePrice = currentBaseComparePrice;
        let addonsPrice = 0;
        let stemPrice = 0;
        let perStemPrice =
            document
                .getElementById("extra-stem-quantity")
                ?.getAttribute("data-price") ?? 0;

        // Addons price
        if (addonInputs) {
            addonInputs.each(function (i, addonInput) {
                addonsPrice += $(addonInput).data("price");
            })
        }

        //Extra stems
        if (quantityInput) {
            const stemQuantity = parseInt(quantityInput.value) || 0;
            stemPrice = stemQuantity * parseFloat(perStemPrice);
        }

        const combinedPrice =
            basePrice + addonsPrice + stemPrice;

        let formattedComparePrice = null;
        if (baseComparePrice > 0) {
            const combinedComparePrice =
                baseComparePrice +
                addonsPrice +
                stemPrice;
            formattedComparePrice = "$" + combinedComparePrice.toLocaleString();
        }
        const formattedPrice = "$" + combinedPrice.toLocaleString();

        return {
            price: formattedPrice,
            comparePrice: formattedComparePrice,
        };
    }

    function syncPriceWithSelections() {
        const combinedPrices = calculateCombinedPrice();
        updatePrice(combinedPrices.price, combinedPrices.comparePrice);
        resetAddtoCart();
    }


    // Extra stem addon wrap logic
    const quantityInput = document.querySelector("input#extra-stem-quantity");
    const incrementBtn = document.querySelector("button.extra-stem-increment");
    const decrementBtn = document.querySelector("button.extra-stem-decrement");

    function updateExtraStemHiddenInput() {
        const currentValue = parseInt(quantityInput.value);
        const hiddenInputs = document.querySelector(".hidden-inputs-wrapper");

        if (currentValue > 0) {
            hiddenInputs.innerHTML = `
        <input type="hidden" id="extra_stem_props" name="properties[Bundle ID]" data-stem="${quantityInput.value}" value="${currentVariantId}" >
      `;
        } else {
            hiddenInputs.innerHTML = "";
        }
    }

    $('.addon-wrapper .radio-inline.extra-stem-quantity-input').on("click", function (e) {
        const currentValue = parseInt(quantityInput.value);

        if (decrementBtn.contains(e.target)) {
            quantityInput.value = currentValue - 1;
            if (currentValue == 1) {
                quantityInput.classList.remove('extra-stem-added');
                quantityInput.setAttribute("checked", false);
            }
        } else if (incrementBtn.contains(e.target)) {
            if (currentValue < 10) {
                quantityInput.value = currentValue + 1;
            }
        }
        if (currentValue == 0) {
            quantityInput.value = 1;
            quantityInput.classList.add('extra-stem-added');
        }
        quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
        if (quantityInput) {
            updateExtraStemHiddenInput();
        }
    });

    document.addEventListener("variant:change", (event) => {
        const variantId = event.detail.id;
        const variantSelect = document.getElementById("variant-select");
        if (variantSelect) {
            const matchingOption = variantSelect.querySelector(
                `option[value="${variantId}"]`
            );
            if (matchingOption) {
                const priceInfo = matchingOption.getAttribute("data-price-info");
                const metaTextElement = document.querySelector(
                    ".product__info-container .has-additional-product .meta-text"
                );
                if (metaTextElement && priceInfo && priceInfo.trim() !== "") {
                    metaTextElement.textContent = priceInfo;
                }
            }
        }
        currentVariantId = event.detail.id;
        currentBasePrice = event.detail.price
            ? Math.round(event.detail.price / 100)
            : 0;
        currentBaseComparePrice = event.detail.compare_at_price
            ? Math.round(event.detail.compare_at_price / 100)
            : 0;

        if (quantityInput) {
            updateExtraStemHiddenInput();
        }

        const priceElement = document.querySelector(
            ".product__info-container .has-additional-product .price--large"
        );
        if (priceElement) {
            if (!event.detail.available) {
                priceElement.classList.add("price--sold-out");
            } else {
                priceElement.classList.remove("price--sold-out");
            }

            if (
                event.detail.compare_at_price &&
                event.detail.price &&
                event.detail.compare_at_price > event.detail.price
            ) {
                priceElement.classList.add("price--on-sale");
            } else {
                priceElement.classList.remove("price--on-sale");
            }
        }
        const combinedPrices = calculateCombinedPrice();
        updatePrice(combinedPrices.price, combinedPrices.comparePrice);
    });

    // Reset CTA button to "Add to cart"
    window.resetAddtoCart = function () {
        var button = $(".product-form__buttons .product-form__submit");

        var btn_bar = $(".addons-btn-wrap");
        document.querySelector(
            ".product-form__submit"
        ).dataset.additionalProductsHandled = "false";

        if (button.hasClass("sec-checkout-btn")) {
            button.removeClass("sec-checkout-btn disabled").find("span").first().text("Add to Cart");
            button.attr("aria-disabled", "false").prop("disabled", false);
            btn_bar.removeClass("show");
        }
        $(".addtocart-btn-trigger .button")?.removeClass("sec-checkout-btn sec-cart-btn disabled")
            .prop("aria-disabled", false)
            .prop("disabled", false)
            .find('span.button__title').text("Add to Cart");
    }

    // Reset A2C when cart is updated to be empty
    $(document).on('cart:updated', function (event) {
        if (event.detail?.itemCount === 0) {
            resetAddtoCart();
        }
    });
    $(document).on('variant:change', function () {
        syncPriceWithSelections();
    })
    $(document).on('change', '.addon-wrapper input', function () {
        syncPriceWithSelections();
    })

    // Addon add logic
    $(document).on('click', '.product-form__submit[name="add"]', function (event) {
        if (this.dataset.additionalProductsHandled === "true") return;

        const btn = $(this);
        const inputs = $('.addon-wrapper .addons-block input:is(:checked, .extra-stem-added)');

        btn.attr('aria-disabled', true)
            .addClass('loading disabled')
            .find('.loading-overlay__spinner').removeClass('hidden');

        if (inputs.length === 0) {
            this.dataset.additionalProductsHandled = "true";
            btn.attr('aria-disabled', false);
            btn.submit();
            return;
        }

        const items = [];

        inputs.each(function (i, input) {
            if (input.classList.contains("extra-stem-quantity")) {
                items.push({
                    id: $(input).data("variant-id"),
                    quantity: $(input).val(),
                    properties: {
                        "Bundle ID": currentVariantId
                    }
                });
            } else {
                items.push({
                    id: $(input).data("variant-id"),
                    quantity: $(input).val()
                });
            }
        });

        this.dataset.additionalProductsHandled = "true";
        event.preventDefault();

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ items: items }),
            contentType: 'application/json',
            dataType: 'json',
            success: function (res) {
                btn.attr('aria-disabled', false);
                btn.click();
            },
            error: function (err) {
                console.error('Error:', err);
            }
        });
    });

    // Trigger variant option changes to sync the hidden input id
    function initialVariantRefresh() {
        const variantSelectElem = document.querySelector('variant-selects');
        const inputs = variantSelectElem.querySelectorAll('select, input');
        variantSelectElem.dispatchEvent(new Event('change', { bubbles: true }));

        inputs.forEach(input => {
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
    window.calculateCombinedPrice = calculateCombinedPrice;
    window.updatePrice = updatePrice;
    initialVariantRefresh();
});
